/**
 * Gemini (Google) Configuration
 *
 * Chat models are prefixed with "gemini/" to route through GeminiProvider
 * (mirrors grok.ts / deepseek.ts's pattern). Image models (e.g.
 * "gemini-3.1-flash-image", "Nano Banana 2") are NOT prefixed and are
 * configured separately in ChatSettingsPanel.tsx's IMAGE_MODEL_OPTIONS —
 * they route through the /api/image/generate hybrid picker, not this file.
 */

export const GEMINI_MODELS = {
  // Legacy — formerly the "Everyday" tier's model app-wide, superseded by
  // OPENAI_MODELS.GPT_5_6_TERRA (see config/openai.ts). Kept resolvable for
  // any thread/automation still pinned to the old id.
  GEMINI_3_7_FLASH: 'gemini/gemini-3.7-flash',
};

export const DEFAULT_GEMINI_MODEL = GEMINI_MODELS.GEMINI_3_7_FLASH;

export const AVAILABLE_GEMINI_MODELS = [
  {
    id: GEMINI_MODELS.GEMINI_3_7_FLASH,
    name: 'Gemini 3.7 Flash',
    provider: 'gemini',
    family: 'gemini',
    description: 'Legacy — balanced everyday model for writing and analysis (superseded by GPT-5.6 Terra)',
    capabilities: ['text', 'reasoning', 'vision'],
    tier: 'legacy',
  },
];

/**
 * Check if a model ID is a Gemini chat model (routed through GeminiProvider).
 */
export function isGeminiModel(modelId: string): boolean {
  return modelId.startsWith('gemini/');
}

/**
 * Get Gemini model name without prefix
 */
export function getGeminiModelName(modelId: string): string {
  return modelId.replace('gemini/', '');
}
